import React, { Component } from 'react';

class ImageRenderer extends Component {
    // static proptypes = {
    //     children: PropTypes.func.isRequired
    // }

    state = {
        mediaData: null
    }

    componentDidMount() {
        this.updateDataFromProps(this.props)
    }

    componentWillReceiveProps(props) {
        this.updateDataFromProps(props);
    }

    updateDataFromProps = (props) => {

        if (!props)
            return

        const { data = null } = props;

        this.setState({ mediaData: data });
    }

    render() {
        const { mediaData = null } = this.state;

        if (!mediaData) {
            return null;
        }

        const { FileID = -1, UploadFile = "", scale = "contain" } = mediaData;

        return (
            <img alt={FileID} id={FileID} src={UploadFile} style={{ width: '100%', height: '100%', objectFit: scale, pointerEvents: "none" }}></img>
        )
    }
}

export default ImageRenderer